import { render, staticRenderFns } from "./RequestedIntegrations.vue?vue&type=template&id=55f27060&scoped=true&"
import script from "./RequestedIntegrations.vue?vue&type=script&lang=ts&"
export * from "./RequestedIntegrations.vue?vue&type=script&lang=ts&"
import style0 from "./RequestedIntegrations.vue?vue&type=style&index=0&id=55f27060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f27060",
  null
  
)

export default component.exports